import React, {useState} from "react";
import {Box, InputLabel, TextField, Select, MenuItem, Button} from "@mui/material";

const formConfig = [
    {name: "page", label: "Page", value: 1, error: "", type: "number"},
    {name: "size", label: "Size", value: 100, error: "", type: "number"},
    {name: "benefitId", label: "Benefit Id", value: "", error: "", type: "number"},
    {name: "sort", label: "Sort By", value: 'asc', items: ['asc', 'desc'], error: "", type: "array"},
    {
        name: "status",
        label: "Status",
        value: 'AVAILABLE',
        items: ['AVAILABLE', 'ISSUED'],
        error: "",
        type: "array"
    },

];
export const Filter = ({onSubmit}) => {
    const [formInputs, setFormInputs] = useState(formConfig);

    const handleSubmit = (event) => {
        event.preventDefault();

        const obj = {};
        formInputs.forEach((formInput) => {
            obj[formInput.name] = formInput.value;
        })

        onSubmit(obj);
    }

    const setForms = (e) => {
        e.preventDefault();

        const name = e.target.name;
        const value = e.target.value;

        formInputs.forEach((formValue) => {
            if (formValue.name === name) {
                formValue.value = value;
                formValue.error = "";
            }
        });

        setFormInputs([...formInputs]);
    }

    const renderForm = ({type, items, label, value, name, error}, key) => {
        switch (type) {
            case 'number':
                return (<Box key={key}>
                    <InputLabel htmlFor="input-with-icon-adornment">
                        {label}
                    </InputLabel>
                    <TextField
                        fullWidth
                        type={type}
                        id={name}
                        value={value}
                        name={name}
                        error={error ? true : false}
                        helperText={error}
                        onChange={setForms}
                    />
                </Box>)
            case 'array':
                return (<Box key={key}>
                    <InputLabel htmlFor="input-with-icon-adornment">
                        {label}
                    </InputLabel>
                    <Select
                        fullWidth
                        id={name}
                        value={value}
                        label={label}
                        name={name}
                        onChange={setForms}
                    >
                        {items.map((val, ind) => (<MenuItem key={ind} value={val}>{val}</MenuItem>))}
                    </Select>
                </Box>)
            default:
                return (<div key={key}>Not Found Type</div>)
        }
    }

    return (
        <form onSubmit={handleSubmit}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    flexDirection: "row",
                    alignItems: "center",
                }}
            >
                {formInputs.map((data, index) => {
                    return renderForm(data, index);
                })}
                <Button
                    type="submit"
                    variant="contained"
                >
                    Search
                </Button>
            </Box>
        </form>
    );
};
